import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Star, StarBorder } from '@material-ui/icons';

import { generateID } from 'utils/helpers';

import styles from './SingleStar.css';


const STAR_FILL_OPTIONS = {
  EMPTY: 'empty',
  FULL: 'full',
};

const IDS = {
  prefix: '28dj37fh',
  element: 'SingleStar',
  star: 'star',
};

const makeId = generateID(IDS.prefix, IDS.element);

const SingleStar = (props) => {
  const {
    ammountFilled,
    emptyStarProps,
    filledStarProps,
    index,
    onClick,
    onMouseEnter,
    onMouseLeave,
  } = props;

  const starClass = classNames({
    [styles.starBase]: true,
    [styles.full]: ammountFilled === STAR_FILL_OPTIONS.FULL,
    [styles.empty]: ammountFilled === STAR_FILL_OPTIONS.EMPTY,
  });

  const handleOnMouseEnter = useCallback((e) => onMouseEnter(e, index), [index, onMouseEnter]);
  const handleOnMouseLeave = useCallback((e) => onMouseLeave(e, index), [index, onMouseLeave]);
  const handleClick = useCallback((e) => onClick(e, index), [index, onClick]);

  return (
    <div
      className={styles.starContainer}
      id={`${makeId(IDS.star)}-${index}`}
      onClick={handleClick}
      onMouseEnter={handleOnMouseEnter}
      onMouseLeave={handleOnMouseLeave}
    >
      <div className={starClass}>
        <Star {...filledStarProps} />
      </div>
      <div>
        <StarBorder {...emptyStarProps} />
      </div>
    </div>
  );
};

SingleStar.propTypes = {
  index: PropTypes.number.isRequired,
  ammountFilled: PropTypes.string,
  emptyStarProps: PropTypes.object,
  filledStarProps: PropTypes.object,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
};

SingleStar.defaultProps = {
  ammountFilled: STAR_FILL_OPTIONS.EMPTY,
  emptyStarProps: {},
  filledStarProps: {},
  index: undefined,
  onClick: () => undefined,
  onMouseEnter: () => undefined,
  onMouseLeave: () => undefined,
};

export default React.memo(SingleStar);
